import styled from 'styled-components';

export const Banner = styled.div`
    padding: 20px;
    display: flex;
    background: #2a2a2a;
    color: white;
    justify-content: center;

    h4 {
        line-height: 28px;
        text-align: center;
        padding: 0 16px;
    }

    a {
        color: #26bbff;
        text-decoration: underline;
        &:hover {
            color: #61cdff;
        }
    }
`;
